import React from "react";

const PaymentInput = ({ amount, onAmountChange, onConfirmClick, isLoading }) => {
  return (
    <>
      <div className="pl-2">
        Nhập số tiền bạn muốn nạp, bấm xác nhận, mở app và quét mã.
      </div>
      <div className="flex items-center py-2">
        <input
          type="number"
          placeholder="Nhập số tiền"
          value={amount}
          onChange={onAmountChange}
          className="w-full bg-[#29293B] text-white p-2 rounded-xl mr-3"
        />
        <button
          disabled={isLoading}
          className="bg-[#255581] hover:bg-[#0E7CC2] text-white w-[131px] py-2 px-4 rounded-lg"
          onClick={onConfirmClick}
        >
          {isLoading ? "Đang xử lý..." : "Xác nhận"}
        </button>
      </div>
    </>
  );
};

export default PaymentInput;
